module.exports = __webpack_public_path__ + "media/components/home/sign-up-free/img/sign-up-free-min-14236866d9a7d867785f3325c3339cec.jpg";